<template>
    <vue-select
        :value="value"
        @input="handleInput"
        v-if="options"
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
        label="string"
        @option:created="clearCache"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på sträng</em>
        </template>
    </vue-select>
</template>

<script>
import VueSelect from '@components/Wrappers/VueSelect';
import BackendRepository from '@services/repositories/BackendRepository';
import Cache from '@services/Cache';

export default {
    name: 'SalesCrmStringsFilter',
    components: {
        VueSelect,
    },
    props: {
        value: null,
        type: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            options: null,
        };
    },
    async created() {
        this.options = await this.getOptions();
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        async getOptions() {
            let options = [];
            await BackendRepository.getSalesCrmStrings().then((res) => {
                if (res[this.type]) {
                    options = res[this.type].map((item) => ({
                        label: item.string,
                        ...item,
                    }));
                }
            });

            return options;
        },
        clearCache() {
            Cache.delete('sales-crm-strings');
        },
    },
};
</script>
